// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CollapsibleDropdown {
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.CollapsibleDropdown__overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 80;
  background: transparent;
  cursor: default;
}
.CollapsibleDropdown__trigger {
  display: flex;
  align-items: center;
  column-gap: 10px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
}
.CollapsibleDropdown__content {
  z-index: 1000;
  position: absolute;
  left: 0;
  top: calc(100% + 12px);
}`, "",{"version":3,"sources":["webpack://./src/components/collapsible-dropdown/collapsible-dropdown.styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AACF;AACE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;AAAJ;AAGE;EACE,aAAA;EACA,kBAAA;EACA,OAAA;EACA,sBAAA;AADJ","sourcesContent":[".CollapsibleDropdown {\n  position: relative;\n  user-select: none;\n\n  &__overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 80;\n    background: transparent;\n    cursor: default;\n  }\n\n  &__trigger {\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n    cursor: pointer;\n    background: none;\n    border: none;\n    padding: 0;\n    font: inherit;\n    color: inherit;\n  }\n\n  &__content {\n    z-index: 1000;\n    position: absolute;\n    left: 0;\n    top: calc(100% + 12px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
